export default __webpack_public_path__ + "static/media/save-content-background.4e711ba6.svg";